import GroupTravelForm from "./pages/group-travel-form/group-travel-form";
import { FormProvider } from "./features/auto-form";
const App = ({market}) => {
  return (
      <FormProvider>
        <GroupTravelForm market={market} />
      </FormProvider>
  );
};

export default App;
